import { NavItem } from 'src/app/layouts/full/vertical/sidebar/nav-item/nav-item';

/** Menú fijo modo Atención (#192): profundidad 1, sin secciones. */
export const ATTENTION_NAV_ITEMS: NavItem[] = [
  {
    displayName: 'Abonados',
    iconName: 'users',
    route: '/apps/customers',
    permission: 'Customers.GetAll',
    activeRoutePrefixes: ['/apps/customers'],
  },
  {
    displayName: 'Facturación pendiente',
    iconName: 'file-invoice',
    route: '/apps/billing-suggestions',
    permission: 'BillingSuggestions.GetAll',
    activeRoutePrefixes: ['/apps/billing-suggestions'],
  },
  {
    displayName: 'Ocupación',
    iconName: 'cash',
    route: '/apps/ParkingOccupancy',
    permission: 'ParkingOccupancy.View',
    activeRoutePrefixes: ['/apps/ParkingOccupancy', '/apps/PayDetection'],
  },
  {
    displayName: 'Caja',
    iconName: 'cash-register',
    route: '/apps/CashBoxes',
    permission: ['CashBox.GetAll', 'CashBox.GetById'],
    permissionMode: 'any',
    activeRoutePrefixes: ['/apps/CashBoxes'],
  },
  {
    displayName: 'Notificaciones',
    iconName: 'mail',
    route: '/apps/communications',
    permission: 'Communications.GetAll',
    activeRoutePrefixes: ['/apps/communications'],
  },
  {
    displayName: 'Visitantes',
    iconName: 'user-plus',
    route: '/apps/visitor-invitations',
    permission: 'VisitorInvitations.GetAll',
    activeRoutePrefixes: ['/apps/visitor-invitations'],
  },
  {
    displayName: 'Plantillas de Notificación',
    iconName: 'clipboard-text',
    route: '/apps/notification-templates',
    permission: 'NotificationTemplates.GetAll',
    activeRoutePrefixes: ['/apps/notification-templates'],
  },
];
